import { useQuery } from "react-query";
import { CommApiInstance } from "Utils/CommApiInstance";

import TrmsCtxtDataType from "Interface/Apis/TrmsCtxt.Interface";

const TrmsCtxtInqApi = async (
    gameSvcCd:string        ,
    trmsKindCd:string       ,
    aplyStrtDtime:string|null,
) => {
    const url = aplyStrtDtime 
        ? `/${gameSvcCd}/trms/${trmsKindCd}/${aplyStrtDtime}`
        : `/${gameSvcCd}/trms/${trmsKindCd}/00000000000000`;
        
    return await CommApiInstance.post(url, {
        apiBody:{
            
        }
    })
    .then((Resp) => Resp.data);
}


export default TrmsCtxtInqApi;